import React from 'react'
import { Progress, Typography } from 'antd'
import { useIntl } from 'react-intl'

const { Text } = Typography

interface ImportProgressProps {
  completedBatches: number
  totalBatches: number
  importedUsers: number
  totalUsers: number
}

const ImportProgress: React.FC<ImportProgressProps> = ({ completedBatches, totalBatches, importedUsers, totalUsers }) => {
  const { formatMessage } = useIntl()
  const percent = totalUsers > 0 ? Math.round((importedUsers / totalUsers) * 100) : 0

  return (
    <div style={{ textAlign: 'center', padding: '48px 24px' }}>
      <Progress type="circle" percent={percent} format={() => `${importedUsers}/${totalUsers}`} />
      <div style={{ marginTop: 24 }}>
        <Text strong style={{ fontSize: 16 }}>
          {formatMessage({ id: 'components.importUsersForm.importingProgress' }, { completed: importedUsers, total: totalUsers })}
        </Text>
      </div>
      {totalBatches > 1 && (
        <div style={{ marginTop: 8 }}>
          <Text type="secondary">
            {formatMessage({ id: 'components.importUsersForm.importingBatch' }, { current: Math.min(completedBatches + 1, totalBatches), total: totalBatches })}
          </Text>
        </div>
      )}
    </div>
  )
}

export default ImportProgress
